export class NotaFiscalModel {
    municipio: string;
    razaoSocial: string;
    dataEmissao: Date;
    numero: number;
    dataCadastroNBP: Date;
    valor: number;
    notaParticipante: string;
    modeloNotaFiscal: string;
    modeloNotaFiscalId: number;
    linkEspelhoNota: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/notaFiscal.model.ts